import type { SimpleRequestConfig } from 'modules/app/types';
import { simpleRequestsLoader } from 'modules/app/utils';
import * as brandActions from 'modules/brands/actions';
import type { Brand, FetchBrandsByDealerAction, FetchBrandsByGroupAction } from 'modules/brands/types';
import type { MetaAction } from 'modules/global/generic.types';

import * as types from '../actionsType';

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.FETCH_BRAND_REQUEST]: {},
  [types.FETCH_ALL_BRANDS_REQUEST]: {},
  [types.FETCH_BRANDS_BY_DEALER_REQUEST]: {
    callbacks: {
      success: (data: Brand[], _meta: MetaAction, { payload }: FetchBrandsByDealerAction) =>
        brandActions.fetchBrandsByDealerSuccess(data, payload.dealerId),
    },
  },
  [types.FETCH_BRANDS_BY_GROUP_REQUEST]: {
    callbacks: {
      success: (data: Brand[], _meta: MetaAction, { payload }: FetchBrandsByGroupAction) =>
        brandActions.fetchBrandsByGroupSuccess(data, payload.groupId),
    },
  },
};

const brandSagas = simpleRequestsLoader(simpleRequests);

export default brandSagas;
